import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

//Material
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import {
  MatPaginatorIntl,
  MatPaginatorModule,
} from '@angular/material/paginator';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgxMaskModule } from 'ngx-mask';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { DateFormatPipe, DateTimeFormatPipe } from '../pipes/date-format.pipe';
import { FiltroOrgPipe } from '../pipes/filtro-org.pipe';
import { PaginatorPipe } from '../pipes/paginator.pipe';
import { MyCustomPaginatorIntl } from './data/setingListLanguage';

//emojis
import { PickerModule } from '@ctrl/ngx-emoji-mart';

//lottie
import player from 'lottie-web';
import { LottieModule } from 'ngx-lottie';
import { FormatPipe } from '../pipes/format.pipe';

import { ContentLoaderModule } from '@ngneat/content-loader';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [PaginatorPipe, FiltroOrgPipe, DateFormatPipe, DateTimeFormatPipe, FormatPipe],
  imports: [
    CommonModule,
    RouterModule,
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSelectModule,
    ContentLoaderModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    NgxChartsModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatRadioModule,
    MatSnackBarModule,
    MatTableModule,
    NgxMaskModule.forRoot(),
    MatSlideToggleModule,
    MatPaginatorModule,
    MatCheckboxModule,
    PickerModule,
    NgxMaterialTimepickerModule,
    MatAutocompleteModule,
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 16,
      innerStrokeWidth: 8,
      outerStrokeColor: '#78C000',
      innerStrokeColor: '#C7E596',
      animationDuration: 300,
    }),
    MatExpansionModule,
    LottieModule.forRoot({
      player: playerFactory,
    }),
  ],
  exports: [
    RouterModule,
    HttpClientModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    TranslateModule,
    MatSelectModule,
    NgxChartsModule,
    MatTooltipModule,
    MatDatepickerModule,
    MatRadioModule,
    MatSnackBarModule,
    MatTableModule,
    NgxMaskModule,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatCheckboxModule,
    PaginatorPipe,
    FiltroOrgPipe,
    DateFormatPipe,
    DateTimeFormatPipe,
    FormatPipe,
    PickerModule,
    NgxMaterialTimepickerModule,
    MatAutocompleteModule,
    NgCircleProgressModule,
    MatExpansionModule,
    LottieModule,
    ContentLoaderModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-MX' },
    { provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl },
  ],
})
export class SharedModule {}
